import React from "react";
import s from "./style.module.scss";
import AvatarPlaceholder from "./icons/AvatarPlaceholder";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import Settings from "./icons/Settings";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import ImageLazy from "shared/ui/ImageLazy";

const AccountInfo: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <div className={s.info}>
      <div>
        <div className={s.avatar}>
          {user_info?.avatar ? (
            <ImageLazy src={user_info.avatar} alt="Avatar" />
          ) : (
            <AvatarPlaceholder />
          )}
        </div>

        <h4>{user_info?.fullname ? user_info?.fullname : "Гость"}</h4>
      </div>

      <Link to={ROUTES_PATH.PROFILE}>
        <Settings />
        Редактировать
      </Link>
    </div>
  );
};

export default AccountInfo;
